module.exports = "---\nsummary: Represents a single day in the Gregorian calendar.\nfields:\n  year:\n    summary: The year.\n  month:\n    summary: The month of the year, where January is represented by the value 1.\n  day:\n    summary: The day of the month.\n---\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/reference/content/happyco.type.v1/Date/overview.md
// module id = 247
// module chunks = 0